import { Belleza } from "../../components";

export const CategoriaBelleza = () => (
  <div>
    <Belleza />
  </div>
);

export default CategoriaBelleza;
